import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchTimeZones } from "../../redux/reducers/user/slice";

export default function TimezoneList({ value, onChange }) {
  const dispatch = useDispatch();
  const { timeZones, timeZonesLoading, timeZonesFetched } = useSelector((state) => state.user);
  const [userTimezone, setUserTimezone] = useState(null);

  React.useEffect(() => {
    if (!timeZones.length && !timeZonesLoading && !timeZonesFetched) {
      dispatch(fetchTimeZones());
    }
  }, [dispatch, timeZones, timeZonesLoading, timeZonesFetched]);

  useEffect(() => {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setUserTimezone(userTimeZone);
  }, []);

  const selectedTimezoneId = timeZones.find(
    (timezone) => timezone.co === userTimezone
  )?.id;

  useEffect(() => {
    if (selectedTimezoneId) {
      onChange(selectedTimezoneId);
    }
  }, [selectedTimezoneId]);

  return (
    <FormControl fullWidth sx={{ mt: 2 }}>
      <InputLabel id="timezone-select-label">Timezone</InputLabel>
      <Select
        labelId="timezone-select-label"
        id="timezone-select"
        value={value}
        label="Timezone"
        onChange={(e) => onChange(e.target.value)}
        disabled={timeZonesLoading}
      >
        {timeZones.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
